import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class TooltipService extends Service {
  @tracked text;
  @tracked element;
  @tracked placement;
  @tracked styles;
  @tracked lines;

  @action
  showTooltip(element, text, placement, styles, lines) {
    this.element = element;
    this.text = text;
    this.placement = placement;
    this.styles = styles;
    this.lines = lines;
  }

  @action
  hideTooltip() {
    this.text = null;
    this.lines = null;
  }
}
